import { ContainerContextValueType, HomePageEditorProviderProps, Item } from '@src/lib/types/home-page-editor';
import { useInputHelper } from '@src/utils/inputs-helper';
import _ from 'lodash';
import React, { createContext, useContext } from 'react';
import { useHomePageEditorContext } from '../provider';

const initialState: Item = {
  "description": "",
  "image": "",
} as Item

export const CreateContext = createContext<ContainerContextValueType>({} as ContainerContextValueType);

const CreateProvider = ({ children }: HomePageEditorProviderProps) => {
  const [error, setError ] = React.useState({});
  const { state, onSetInitial, onDispatch, handleFormReset } = useInputHelper(initialState);
  const { openDescription, state: STATE, setOpenDescription, onDispatch: ONDISPATCH } = useHomePageEditorContext();

  const onSubmit = React.useCallback(() => {
    const Err: any = {};
    if(!state.description){
      Err.description = true
    }

    setError(Err);

    if(_.isEmpty(Err)){
      ONDISPATCH("mainBlock.description")(state.description);
      setOpenDescription(false);
    }
  }, [state, ONDISPATCH, setOpenDescription]);

  const value = {
    state,
    error,
    onDispatch,
    onSubmit
  };

  React.useEffect(() => {
    if(!_.isEmpty(error)){
      setError({});
    }
  },[state, error]);

  React.useEffect(() => {
    if(openDescription){
      const item = STATE["mainBlock"] || {};
      onSetInitial(item);
    }

    return () => {
      handleFormReset();
    }
  },[openDescription, STATE, handleFormReset, onSetInitial]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <CreateContext.Provider value={value}>
      {children}
    </CreateContext.Provider>
  );
};

export const useCreateContext = () => {
  return useContext(CreateContext);
}

export default CreateProvider;
